import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { LOGIN_STATUS, STORAGE_KEY } from "../../utils/Constant";
import { logout, registeredEmp } from "../../services";
import {
  clearSession,
  getFromLocalStorage,
  removeFromLocalStorage,
  saveInLocalStorage,
} from "../../utils/Util";

const blankUser = {
  candidateId: 0,
  candidateUniqueId: "",
  employeeUniqueId: "",
  firstname: "",
  lastName: "",
  employeeName: "",
  userActivationStatus: 0,
  userActivationStatusName: "",
  accessToken: "",
  accessExpiryTime: "",
  refreshToken: "",
  resetExpiryTime: "",
  mobileNumber: 0,
  emailId: "",
  loginType: 0,
  loginTypeName: "",
  roleId: -1,
  permissions: [],
  roleName: '',
  userId: '',
  sessionId: ''
};

export const initialState = {
  status: LOGIN_STATUS.NO_AUTHENTICATED,
  user: blankUser,
};

export const getRegisteredEmployees = createAsyncThunk("dummyAPI", async () => {
  const res = await registeredEmp({});
  return res.data;
});

export const onLogout = createAsyncThunk("update/logout", async () => {
  const res = await logout();
  return res.data;
});

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setAuthenticated: (state, action) => {
      state.status = action.payload.status;
      state.user = action.payload.user;
      saveInLocalStorage(
        STORAGE_KEY.AUTH_DATA,
        JSON.stringify(action.payload.user)
      );
    },
    setLocalLogout: (state, action) => {
      state.status = LOGIN_STATUS.NO_AUTHENTICATED;
      state.user = blankUser;
      removeFromLocalStorage(STORAGE_KEY.AUTH_DATA);
      removeFromLocalStorage(STORAGE_KEY.ITUS);
      localStorage.clear();
      clearSession();
    },
    checkAuthenticated: (state, action) => {
      const data = getFromLocalStorage(STORAGE_KEY.AUTH_DATA);
      if (data) {
        const sessionData = JSON.parse(data);
        if (sessionData && sessionData.accessToken) {
          state.status = LOGIN_STATUS.AUTHENTICATED;
          state.user = sessionData;
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRegisteredEmployees.fulfilled, (state, action) => {
        state.status = LOGIN_STATUS.AUTHENTICATED;
      });
  },
});

export const loginSelector = (state) => state.login;
export const { setAuthenticated, setLocalLogout, checkAuthenticated } = loginSlice.actions;
export default loginSlice.reducer;